import { render, staticRenderFns } from "./RegionsAdmin.vue?vue&type=template&id=cfe850b2&scoped=true"
import script from "./RegionsAdmin.vue?vue&type=script&lang=js"
export * from "./RegionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./RegionsAdmin.vue?vue&type=style&index=0&id=cfe850b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe850b2",
  null
  
)

export default component.exports